import { render, staticRenderFns } from "./ProCard3.vue?vue&type=template&id=2c8d60cb&scoped=true"
import script from "./ProCard3.vue?vue&type=script&lang=js"
export * from "./ProCard3.vue?vue&type=script&lang=js"
import style0 from "./ProCard3.vue?vue&type=style&index=0&id=2c8d60cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8d60cb",
  null
  
)

export default component.exports